import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { createRoleMap } from '../../../utility/helpers/createRoleMap';
import { getRolesForOrg } from '../data-access/getRolesForOrg';

import type { RoleMap } from '../../../../types';
import type { UseQueryResult } from '@tanstack/react-query';

type UseOrganizationRolesResult = UseQueryResult<AdminTypes.Role[], unknown> & {
  roleMap: RoleMap;
};

export const useOrganizationRoles = (
  orgId?: string,
): UseOrganizationRolesResult => {
  const query = useQuery({
    queryKey: ['org', orgId, 'roles'],
    queryFn: () => getRolesForOrg(orgId as string),
    enabled: orgId !== undefined,
  });

  const roleMap = useMemo(() => createRoleMap(query.data), [query.data]);

  return {
    ...query,
    roleMap,
  };
};
